exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".save-status_save-now_2shdk {\n    font-family: \"Helvetica Neue\", Helvetica, Arial, sans-serif;\n    cursor: pointer;\n}\n\n.save-status_save-button_1UEJ9 {\n    height: 32px;\n    margin-left: 12px;\n    background-color: #ff8c1a;\n    border-radius: 16px;\n    font-size: 14px;\n    color: #ffffff;\n    display: -webkit-box;\n    display: -webkit-flex;\n    display: -ms-flexbox;\n    display: flex;\n    -webkit-box-pack: center;\n    -webkit-justify-content: center;\n        -ms-flex-pack: center;\n            justify-content: center;\n    -webkit-box-align: center;\n    -webkit-align-items: center;\n        -ms-flex-align: center;\n            align-items: center;\n}\n\n.save-status_save-now_2shdk span{\n    padding: 10px;\n}\n", ""]);

// exports
exports.locals = {
	"save-now": "save-status_save-now_2shdk",
	"saveNow": "save-status_save-now_2shdk",
	"save-button": "save-status_save-button_1UEJ9",
	"saveButton": "save-status_save-button_1UEJ9"
};